import { useFrame } from "@react-three/fiber";
import { Center, Text3D } from "@react-three/drei";
import { useRef } from "react";
import { animated } from "@react-spring/three";
import { useAtom } from 'jotai';
import { languageAtom } from '../GlobalState';
import Star from "../meshes/Stars/Star";
import translations from '../dictionaries/translations';
    
export default function GameStartAlert({ scale=1, position=[0,0,0], rotation=[0,0,0] }) {
  const [language] = useAtom(languageAtom);
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";
  
  const borderMesh0Ref = useRef();
  const borderMesh1Ref = useRef();
  const borderMesh2Ref = useRef();
  const borderMesh3Ref = useRef();
  const borderMesh4Ref = useRef();
  const borderMesh5Ref = useRef();
  const borderMesh6Ref = useRef();
  const borderMeshRefs = [
    borderMesh0Ref,
    borderMesh1Ref,
    borderMesh2Ref,
    borderMesh3Ref,
    borderMesh4Ref,
    borderMesh5Ref,
    borderMesh6Ref
  ]
  const width = 2.7
  const height = 2
  useFrame((state, delta) => {
    for (let i = 0; i < borderMeshRefs.length; i++) {      
      if (borderMeshRefs[i].current) {
        borderMeshRefs[i].current.position.x = Math.cos(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * width
        borderMeshRefs[i].current.position.y = 0.1
        borderMeshRefs[i].current.position.z = Math.sin(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * height
      }
    }
  })

  return <animated.group scale={scale} position={position} rotation={rotation}>
    <mesh
      castShadow
      receiveShadow
      scale={[width, 0.055, height]}
    >
      <cylinderGeometry args={[1, 1, 1, 64]}/>
      <meshStandardMaterial color='black' opacity={0.8} transparent/>
    </mesh>
    <Center position={[0, 0, 0]} key={Math.random()}>
      <Text3D
        font={fontUrl}
        rotation={[Math.PI/2, Math.PI, Math.PI]}
        position={[0,0,-1.5]}
        size={0.7}
        height={0.1}
        lineHeight={0.8}
      >
        {translations.alerts.gameStart[language]}
        <meshStandardMaterial color='limegreen'/>
      </Text3D>
    </Center>
    <group ref={borderMesh0Ref}>
      <Star 
        scale={0.2}
      />
    </group>
    <group ref={borderMesh1Ref}>
      <Star 
        scale={0.2}
      />
    </group>
    <group ref={borderMesh2Ref}>
      <Star 
        scale={0.2}
      />
    </group>
    <group ref={borderMesh3Ref}>
      <Star 
        scale={0.2}
      />
    </group>
    <group ref={borderMesh4Ref}>
      <Star 
        scale={0.2}
      />
    </group>
    <group ref={borderMesh5Ref}>
      <Star 
        scale={0.2}
      />
    </group>
    <group ref={borderMesh6Ref}>
      <Star 
        scale={0.2}
      />
    </group>
  </animated.group>
}